import { generateActions } from "helpers/generateActions";

export const GET_DATASHEET_BY_ID = generateActions("GET_DATASHEET_BY_ID");
export const COMPLETE_DATASHEET = generateActions("COMPLETE_DATASHEET");

export const API_ERROR = "API_ERROR";
